// import skill1 from "../assets/img/html5.png";
// import skill2 from "../assets/img/css3.png";
// import skill3 from "../assets/img/js.png";
// import skill4 from "../assets/img/reactjs.png";
// import skill5 from "../assets/img/nextjs.png";
// import skill6 from "../assets/img/nodejs.png";
// import skill7 from "../assets/img/git.png";
// import skill8 from "../assets/img/figma.png";
// import skill7 from "../assets/img/git.png";
// import skill8 from "../assets/img/figma.png";


import colorSharp from "../assets/img/color-sharp.png";
import "./Skills.css";

const getBadge = (name) => {
  const parts = name.split(/[^A-Za-z0-9+.#]+/).filter(Boolean);

  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return parts
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
};

export const Skills = () => {
  const skillGroups = [
    {
      category: "Frontend",
      items: [
        { name: "HTML5", icon: "https://raw.githubusercontent.com/devicons/devicon/54cfe13ac10eaa1ef817a343ab0a9437eb3c2e08/icons/html5/html5-original.svg" },
        { name: "CSS3", icon: "https://raw.githubusercontent.com/devicons/devicon/54cfe13ac10eaa1ef817a343ab0a9437eb3c2e08/icons/css3/css3-original.svg" },
        { name: "JavaScript", icon: "https://raw.githubusercontent.com/devicons/devicon/54cfe13ac10eaa1ef817a343ab0a9437eb3c2e08/icons/javascript/javascript-original.svg" },
        { name: "React", icon: "https://raw.githubusercontent.com/devicons/devicon/54cfe13ac10eaa1ef817a343ab0a9437eb3c2e08/icons/react/react-original.svg" },
        { name: "Next.js", icon: "https://raw.githubusercontent.com/devicons/devicon/54cfe13ac10eaa1ef817a343ab0a9437eb3c2e08/icons/nextjs/nextjs-original.svg" },
      ],
    },
    {
      category: "Backend",
      items: [
        { name: "Node.js", icon: "https://raw.githubusercontent.com/devicons/devicon/54cfe13ac10eaa1ef817a343ab0a9437eb3c2e08/icons/nodejs/nodejs-original.svg" },
        { name: "Python", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" },
        { name: "PHP", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg" },
      ],
    },
    {
      category: "Cloud & DevOps",
      items: [
        { name: "Linux", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linux/linux-original.svg" },
        { name: "Docker", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg" },
        { name: "Jenkins", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg" },
        { name: "AWS", icon: "https://raw.githubusercontent.com/devicons/devicon/54cfe13ac10eaa1ef817a343ab0a9437eb3c2e08/icons/amazonwebservices/amazonwebservices-original-wordmark.svg" },
        { name: "Terraform", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/terraform/terraform-original.svg" },
        { name: "Ansible", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/ansible/ansible-original.svg" },
        { name: "Kubernetes", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg" },
      ],
    },
    {
      category: "Observability",
      items: [{ name: "Prometheus", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/prometheus/prometheus-original.svg" }, { name: "Grafana", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/grafana/grafana-original.svg" }],
    },
    {
      category: "Databases",
      items: [{ name: "MySQL", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg" }, { name: "MongoDB", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" }],
    },
  ];

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="skill-shell">
          <div className="skill-heading">
            <span className="skill-kicker">What I Work With</span>
            <h2>Skills crafted for modern web experiences.</h2>
            <p>
              My toolkit blends frontend engineering, backend foundations,
              cloud workflows, and product-minded design so ideas can move from
              concept to launch with clarity.
            </p>
          </div>

          <div className="skill-groups">
            {skillGroups.map((group) => (
              <article className="skill-group" key={group.category}>
                <div className="skill-group-title">
                  <h3>{group.category}</h3>
                </div>

                <div className="skill-group-card">
                  <div className="skill-group-grid">
                    {group.items.map((item) => (
                      <div
                        className="skill-item"
                        key={item.name}
                        aria-label={item.name}
                        title={item.name}
                      >
                        <div className="skill-item-icon" aria-hidden="true">
                          {item.icon ? (
                            <img src={item.icon} alt={item.name} />
                          ) : (
                            <span className="skill-item-fallback">
                              {getBadge(item.name)}
                            </span>
                          )}
                        </div>
                        <span className="skill-item-name">{item.name}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="" />
    </section>
  );
};
